import type { Mixin } from "./define-component.js";

// withDeclarativeShadow nutzt eine vom HTML-Parser bereits erzeugte
// Declarative-Shadow-Root (`<template shadowrootmode="open">`) wieder
// statt eine neue zu attachen — `host.attachShadow()` wuerde sonst
// werfen ("already hosts a shadow tree"). Ist keine DSD-Root vorhanden
// (rein client-seitig gemountet), attached es selbst eine.
//
// DSD ist die Grundlage fuer SSR-First-Paint + CSS-Isolation der
// `<pfs-shell>` (ADR-0012): der Server liefert die Shell vorgerendert
// im `<template shadowrootmode>`, der Client uebernimmt sie. Idempotent
// gegen Re-Connects; teilt die Root via ComponentContext.
export function withDeclarativeShadow(
  opts: ShadowRootInit = { mode: "open" },
): Mixin {
  return (host, ctx) => ({
    connect() {
      if (ctx.shadowRoot) return;
      ctx.shadowRoot = host.shadowRoot ?? host.attachShadow(opts);
    },
  });
}
